import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { Text, Flex, Box, Link } from '@chakra-ui/react'
import FontAwesomeIconComponent from 'src/components/FontAwesomeIcon/index'

const jssStyles = () => {
  return {
    linkButton: {
      display: 'flex',
      flex: '1',
      justifyContent: 'center',
      whiteSpace: 'nowrap',
      padding: '13px',
    },
  }
}

/**
 * @param {node} children Link content
 * @param {string} href Link URL
 * @param {string} iconType Option icon next to the link content
 * @param {object} classes Styles received from this component (withStyles)
 * @param {object} parentClasses Styles received from parent to overwrite default styles
 * @param {object} rest Rest of the properties, to be passed directly to <a> element
 * @return {*}
 * @constructor
 */
const LinkButton = ({ children, href, iconType, parentClasses, classes, ...rest }) => {
  const classNames = cx({
    [classes.linkButton]: true,
    [parentClasses?.linkButton]: !!parentClasses?.linkButton,
  })

  return (
    <Flex flex={1} justify={'center'} align={'center'}>
      <Link
        href={href}
        style={{ ...jssStyles }}
        target='_blank'
        rel='noopener noreferrer'
        className={classNames}
        {...rest}
      >
        {iconType && (
          <Flex>
            <FontAwesomeIconComponent icon={iconType} size='xs' />
          </Flex>
        )}
        <Box ml={'10px'}>
          <Text fontSize={'14px'} fontWeight={500}>
            {children}
          </Text>
        </Box>
      </Link>
    </Flex>
  )
}

LinkButton.propTypes = {
  className: PropTypes.string,
  href: PropTypes.string,
  iconType: PropTypes.string,
  parentClasses: PropTypes.object,
  // Provided from withStyles()
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
}

export default LinkButton
